import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

const KEY = 'auth_token';

export async function getAuthToken() {
  if (Capacitor.isNativePlatform()) {
    const { value } = await Preferences.get({ key: KEY });
    return value || null;
  }
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export async function setAuthToken(token) {
  if (Capacitor.isNativePlatform()) {
    await Preferences.set({ key: KEY, value: token });
    return;
  }
  try { localStorage.setItem(KEY, token); } catch {}
}

export async function clearAuthToken() {
  if (Capacitor.isNativePlatform()) {
    await Preferences.remove({ key: KEY });
    return;
  }
  try { localStorage.removeItem(KEY); } catch {}
}
